import { PEN_REMAININGYESTERDAY } from '../..';

import { BaseSection } from './_Section/interface';

interface Section_Props extends BaseSection {
  onPenClick?: (penId: number) => void
}
/**
 * SECTION_REMAININGYESTERDAY
 * @param sectionId Unique identifier for each section.
 * @param onPenClick OnClick event to handle penId.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_REMAININGYESTERDAY({ sectionId, pens }: Section_Props) {

  // Error throwback if no section number excists
  if (pens.length === 0) {
    return <div>Section {sectionId} not found</div>;
  }

  const maxRowsAndCols = pens.reduce(
    (acc, pen) => {
      const [endRow, endCol] = pen.visual ? pen.visual.split('/').map(Number) : [0, 0];
      return {
        rows: Math.max(acc.rows, endRow),
        cols: Math.max(acc.cols, endCol),
      };
    },
    { rows: 0, cols: 0 }
  );

  const renderContent = () => {
    return pens.map(pen => (
      <PEN_REMAININGYESTERDAY
        key={pen.location_id}
        pen={pen}
        gridArea={pen.visual}
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
         <div style={{
          display: "grid",
          gridTemplateColumns: `repeat(${maxRowsAndCols.cols}, 1fr)`,
          gridTemplateRows: `repeat(${maxRowsAndCols.rows}, auto)`,
          width: "fit-content",
          gap: "10px",
          borderRadius: "10px",
          overflow: "hidden"
        }}>
          {renderContent()}
        </div>
      </div>
  );
}